import type { PassLinkedOffer } from "../interfaces/pass.interface";

type EventOfferShape = {
  promoCode?: string | null;
  offerStartDate?: string | null;
  offerEndDate?: string | null;
  offerPrice?: number | null;
};

const getDateOnly = (value?: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

const isDateRangeActive = (validFrom?: string | null, validTill?: string | null) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const from = getDateOnly(validFrom);
  const till = getDateOnly(validTill);

  if (from && today < from) return false;
  if (till && today > till) return false;
  return true;
};

export const getActivePassOffer = (offers?: PassLinkedOffer[] | null) =>
  offers?.find((offer) => offer.isActive && isDateRangeActive(offer.validFrom, offer.validTill)) ??
  null;

export const isEventOfferCurrentlyActive = (event: {
  isOfferActive?: boolean | null;
  offerPrice?: number | null;
  standardPrice?: number | null;
  offerStartDate?: string | null;
  offerEndDate?: string | null;
}) =>
  Boolean(
    event.isOfferActive &&
      event.offerPrice !== null &&
      event.offerPrice !== undefined &&
      typeof event.standardPrice === "number" &&
      event.offerPrice < event.standardPrice &&
      isDateRangeActive(event.offerStartDate, event.offerEndDate)
  );

export const getActiveEventOffer = (offers?: EventOfferShape[] | null) =>
  offers?.find(
    (offer) =>
      offer.offerPrice !== null &&
      offer.offerPrice !== undefined &&
      isDateRangeActive(offer.offerStartDate, offer.offerEndDate)
  ) ?? null;
